module.exports = __webpack_public_path__ + "img/20210619_172102.5238ecfd.jpg";